import React from 'react'
import { Link } from 'react-router-dom';
import { fromNow } from '../../../Utils';
import Spinner from '../../../Components/Spinner'
function Products({ items, loading }) {
    ;



    const Item = ({ item }) => {
        const { images, status, category, name, price, id, created_at } = item;
        let textStatus = '';
        switch (status) {
            case 'accept':
                textStatus = 'تایید شده';
                break;

            case 'delete':
                textStatus = 'حذف شده';
                break
            case 'new':
                textStatus = 'در انتظار تایید';
                break
            case 'reject':
                textStatus = 'رد شد';
                break

        }
        return (
            <div className="item">
                <Link to={"/CensusAndVisit/" + id} state={{ item: item }} className="d-flex">
                    <div className="right">
                        <div className="img">
                            <img src={images[0]} alt="image" />
                        </div>
                        <div className={status == "accept" ? "accept" : "deleted"}>
                            {textStatus}
                        </div>
                    </div>
                    <div className="item-info w-100">
                        <div className="d-flex align-items-center justify-content-between">
                            <p>{name}</p>
                            <p>{category && category.title}</p>
                        </div>
                        <div className={` d-flex justify-content-between`}>
                            <span>{price == 'توافقی' ? price : parseInt(price).toLocaleString() + " تومان "}</span>
                            <span>{fromNow(new Date(created_at))}</span>
                        </div>
                    </div>
                </Link>
                {status == "accept" && <div>
                    <div className="detials">
                        <div className="row">
                            <div className="col-4">
                                <Link to={"/CensusAndVisit/" + id} state={{ item: item }}>
                                    <button className="btn">
                                        <i class="text-danger far fa-chart-bar"></i>
                                        <span>آمار بازدید</span>
                                    </button>
                                </Link>
                            </div>
                            <div className="col-4">
                                <Link to={"/DeleteItem/" + id}>
                                    <button className="btn borderx">
                                        <i class="fas fa-trash"></i>
                                        <span>حذف</span>
                                    </button>
                                </Link>
                            </div>
                            <div className="col-4">
                                <Link to={"/EditItem/" + id} state={{ item: item }}>
                                    <button className="btn">
                                        <i class="fas fa-pen"></i>
                                        <span>ویرایش</span>
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>

                </div>}
                {/* {status == "delete" && <button onClick={() => { }} className="activing">
                    <span>فعال سازی</span>
                    <i class="fas fa-check"></i>
                </button>} */}
            </div>
        )
    }
    const Noproduct = () => {
        return (
            <div className="d-grid text-center noproduct">
                <div className="d-flex justify-content-center mb-5">
                    <img src={require("../../../assets/image/mylistings.png")} alt="" />
                </div>
                <span>شما در حال حاضر هیچ آگهی فعالی ندارید !</span>
                <p>خرید و فروش آسان با امکان ثبت 30 آگهی رایگان در ماه</p>
            </div>
        )
    }


    return (
        <div className='profile-bottom pb-5  myproducts-bottom'>
            <div className="items">
                {
                    loading ?
                        <Spinner />
                        :
                        items && items.data && items.data.length ?
                            items.data.map((item, i) => {
                                return <Item item={item} key={i} link={"/item/" + item.id} />;
                            })
                            :
                            <Noproduct />
                }
            </div>
        </div>
    )
}

export default Products